package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TreatmentDetailResponseItem

@Serializable
data class UpdateTreatmentRequest(
    @SerialName("template_id")
    val templateId: Int,
    val types: List<TreatmentDetailResponseItem>
)
